/**
 * ProcessFeedTagsWatchUseCase
 *
 * Triggers the `processFeedTags` cloud function for the given content id.
 *
 * Flutter sources of truth:
 *   - lib/data/repository/feed_tags_repository.dart
 *   - lib/presentation/view_models/content_view_model.dart:325-344 (watch path)
 *   - lib/presentation/view_models/content_view_model.dart:628-631 (like path)
 *
 * Fire-and-forget contract: errors are logged and swallowed (mirrors Flutter).
 */

import { FeedTagsService } from '@/domain/services/feedTags/feedTagsService';
import { appLogger } from '@/domain/services/analytics/appLogger';

export class ProcessFeedTagsWatchUseCase {
  private feedTagsService: FeedTagsService;

  constructor(feedTagsService?: FeedTagsService) {
    this.feedTagsService = feedTagsService || FeedTagsService.getInstance();
  }

  /**
   * Execute the use case.
   * Returns early without calling when contentId is empty.
   * Never throws — errors are logged and swallowed.
   */
  async execute(contentId: string): Promise<void> {
    if (!contentId) {
      return;
    }

    try {
      await this.feedTagsService.processFeedTagsWatch(contentId);
    } catch (error) {
      appLogger.error(
        'Error executing ProcessFeedTagsWatchUseCase',
        'ProcessFeedTagsWatchUseCase', { error: error as Error },
      );
    }
  }
}

// Export singleton instance
export const processFeedTagsWatchUseCase = new ProcessFeedTagsWatchUseCase();
